import { RemExpertResultatTNS } from "components/app/Api/ResultatRemExpertTNSProvider";
import { ApplySignedFormat } from "components/app/ApplySignedFormat";
import { AppContext } from "components/app/RemExprertProvider";
import CardBox from "components/ui/controls/card-box/card-box";
import Pager from "components/ui/controls/pager/pager";
import Modal from "components/ui/modal/modal";
import { applyFormat } from "components/ui/ui-helpers";
import React, { useContext, useState } from "react";
import { FaGlobe, FaMoneyBillWave, FaBuilding, FaDollarSign, FaPiggyBank, FaChartLine } from "react-icons/fa";
import ModalParamDividendes from "./ModalParamDividendes";
import { CompactFinancialOptiRem } from "components/app/AuditRemuneration/Resultat/CompactFinancialCard";

function OptimisationResAvtIS(props) {
  const { Periode, ClientConjoint } = props;
  let CliConjRai = (ClientConjoint === ""  ||ClientConjoint === "ConjointAssocie" )? "" : "Conjoint";
  const context = useContext(AppContext);
  const ResultatTNS = useContext(RemExpertResultatTNS);
  const [modalResultatEntreprise, setmodalResultatEntreprise] = useState(false);
  return (
    <CardBox className="blockRoundedForce" bpad>
      <div style={{ display: "flex", flexDirection: "column", gap: "5px", width: "100%" }}>

        <CompactFinancialOptiRem
          icon={<FaChartLine />}
          title="Résultat avant IS"
          valueOrigine={applyFormat(Periode?.ResAvtIs, "uint", { thousands: " ", decimal: ",", unit: " €" })}
          valueNouvelle={context.state["OptiRemResAvtIs" + ClientConjoint]}
          isEditable={true}
          onChange={(e) => {
            context.handleCalculOptiRem("res_avant_is", "OptiRemResAvtIs" + ClientConjoint, ClientConjoint, ResultatTNS, false, e);
          }}
          valueEcart={ApplySignedFormat(Number(context.state["OptiRemResAvtIs" + ClientConjoint]) - Number(Periode?.ResAvtIs))}
          accentColor="#059669"
        />
        <CompactFinancialOptiRem
          icon={<FaBuilding />}
          title="Impôt sur les sociétés"
          valueOrigine={applyFormat(Periode?.ImpotSoc, "uint", { thousands: " ", decimal: ",", unit: " €" })}
          valueNouvelle={applyFormat(context.state["OptiRemImpotSoc" + ClientConjoint], "uint", { thousands: " ", decimal: ",", unit: " €" })}
          onEdit={() => {
            setmodalResultatEntreprise(true);
          }}
          valueEcart={ApplySignedFormat(Number(context.state["OptiRemImpotSoc" + ClientConjoint]) - Number(Periode?.ImpotSoc))}
          accentColor="#dc2626"
        />
        <CompactFinancialOptiRem
          icon={<FaPiggyBank />}
          title={`Mise en réserve${Number(context.state["OptiRemDivAutres" + ClientConjoint]) !== 0 ? " / div. autres associés" : ""}`}
          valueOrigine={applyFormat(Number(Periode?.Reserve) + Number(Periode?.DividendeBrutAutres), "uint", { thousands: " ", decimal: ",", unit: " €" })}
          valueNouvelle={applyFormat(Number(context.state["OptiRemReserve" + ClientConjoint]) + Number(context.state["OptiRemDivAutres" + ClientConjoint]), "uint", { thousands: " ", decimal: ",", unit: " €" })}
          valueEcart={ApplySignedFormat(Number(context.state["OptiRemReserve" + ClientConjoint]) + Number(context.state["OptiRemDivAutres" + ClientConjoint]) - (Number(Periode?.Reserve) + Number(Periode?.DividendeBrutAutres)))}
          accentColor="#7c3aed"
        />
        <CompactFinancialOptiRem
          icon={<FaDollarSign />}
          title="Dividendes bruts"
          valueOrigine={applyFormat(Periode?.DividendeBrut, "uint", { thousands: " ", decimal: ",", unit: " €" })}
          valueNouvelle={context.state["OptiRemDividendeBrut" + ClientConjoint]}
          isEditable={true}
          onChange={(e) => {
            context.handleCalculOptiRem("dividende_brut", "OptiRemDividendeBrut" + ClientConjoint, ClientConjoint, ResultatTNS, false, e);
          }}
          valueEcart={ApplySignedFormat(Number(context.state["OptiRemDividendeBrut" + ClientConjoint]) - Number(Periode?.DividendeBrut))}
          accentColor="#2563eb"
        />
      </div>

      <Modal
        width="80%"
        height="81%"
        title="Situation professionnelle"
        icon={<FaGlobe />}
        visible={modalResultatEntreprise}
        onClose={() => { 
          context.handleCalculOptiRem("res_avant_is","OptiRemResAvtIs" + CliConjRai, CliConjRai, ResultatTNS,false, context.state["OptiRemResAvtIs" + CliConjRai]);
          setmodalResultatEntreprise(false);
        }}
      > 
        <Pager
          withMenu
          pages={[
            {
              label: "Dividendes",
              icon: <FaMoneyBillWave />,
              content: <ModalParamDividendes Outil={"OptiRem"} ClientConjoint={ClientConjoint} Periode={Periode} />,
            },
          ]}
          page={0}
          navButtons={{
            // cancel: {
            //   onClick: (evt) => {
            //     setmodalResultatEntreprise(false);
            //   },
            // },
            // previous: {},
            // next: {},
            validate: {
              onClick: (evt) => {
                context.handleCalculOptiRem("res_avant_is","OptiRemResAvtIs" + CliConjRai, CliConjRai, ResultatTNS,false, context.state["OptiRemResAvtIs" + CliConjRai]);
                setmodalResultatEntreprise(false);
              },
            },
          }}
        />
      </Modal>
    </CardBox>
  );
}
export default OptimisationResAvtIS;
